import { type TeamData, type TeamId } from '@terros/common'
import { useMemo } from 'react'
import { type UseTeamProps, useTeams } from './list'

export const useTeamMap = (props?: UseTeamProps): Map<TeamId, TeamData> => {
  const { data: teams } = useTeams({ showArchived: 'all', ...props })
  return useMemo(() => {
    return new Map(teams?.map((team) => [team.teamId, team]) ?? [])
  }, [teams])
}
